import {Component, OnInit} from '@angular/core';
import {UserService} from '../../../services/user.service';
import {ActivatedRoute} from '@angular/router';
import {User} from '../../../models/user.model';
import {ConfirmationPopupComponent} from '../view-group/popups/confirmation-popup/confirmation-popup.component';
import {NgbDateParserFormatter, NgbDateStruct, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {AdminService} from '../../../services/admin.service';
import {ApiService} from '../../../services/api.service';
import {TimeFormatterService} from '../../../services/time-formatter.service';
import {LanguageSwitcher} from '../../../header/language-switcher/language-switcher.model';
import {AddDepartments} from '../../../modals/addDepartments/add-departments.component';

@Component({
  selector: 'app-edit-user-profile',
  templateUrl: './edit-user-profile.component.html',
  styleUrls: ['./edit-user-profile.component.css']
})
export class EditUserProfileComponent implements OnInit {
  isSubmited = true;
  isLoaded = false;
  disableRegBtn = false;
  public user: any;
  public wrapperUser: any;

  public editSelf = false;

  public selectedLanguage: string;
  public activeStatus = true;
  public inactiveStatus = false;
  public successInfo = false;
  public errorInfo = false;

  public dateOfEmployment: NgbDateStruct;
  public dateOfDismissal: NgbDateStruct;

  public selectedStatus: string;
  public selectedTesting = 'DISABLE_TESTING';
  public yesTestingStatus = false;
  public noTestingStatus = true;
  public yesTesting;
  public selectedAccess = 'DISABLE_REMOTE_ACCESS';
  public yesAccessStatus = false;
  public noAccessStatus = true;
  public selectedClothingIssue = 'ALLOW_CLOTHING_ISSUE';
  public clothingIssueDisabledStatus = false;
  public clothingIssueAllowedStatus = true;

  public isAdmin = false;
  public isHead = false;
  public isPartner = false;
  public isUser = false;
  public isSpec = false;
  public isStorekeeper = false;

  public userLocal: User;
  public isLocalAdmin = false;

  selectedGroup = 'Select';
  private groupIDForm = null;

  errorGetDataListInfo = false;
  private scheduleForm = null;
  private positionForm = null;
  groupList;

  selectedSchedule = 'Select';
  schedulesList: any[] = [];
  schedulesListNoFormat: any;

  showDepartments = false;
  noValidation = false;
  noValidationText = 'OOMFAFII';
  addedGroups;

  mainGroup = '';

  isCheckTimetable;

  isCheckTimetablePF;

  isOutsourcing;

  constructor(public userService: UserService,
    private route: ActivatedRoute,
    private modalService: NgbModal,
    private adminService: AdminService,
    public parserFormatter: NgbDateParserFormatter,
    public apiService: ApiService,
    private formatService: TimeFormatterService,
    public languageSwitcher: LanguageSwitcher) {
  }

  ngOnInit() {
    const date = new Date();
    this.dateOfEmployment = {
      year: date.getFullYear(),
      month: date.getMonth() + 1,
      day: date.getDate()
    };

    // get schedules
    this.adminService.getSchedules().subscribe(
      (response) => {
        this.schedulesListNoFormat = response.body;
      },
      () => {
        this.errorGetDataListInfo = true;
      },
      () => {
        // Format time;
        // this.schedulesListNoFormat.forEach(item => {
        //   this.schedulesList.push(this.formatService.formatTime(item));
        // });
      }
    );


    this.userService.getUserFromAPI(this.route.snapshot.params['id']).subscribe(
      (response: any) => {
        if (response.status === 200) {
          this.user = response.body;
    
          this.isOutsourcing = response.body.isOutsourcing;
          this.isCheckTimetablePF = response.body.payrollMethod;
          this.isCheckTimetable = response.body.checkTimetable;
          this.yesTestingStatus = response.body.isTestingDisabled;
          if (this.user.id === this.userService.getLocal().id) {
            this.editSelf = true;
          } else {
            this.editSelf = false;
          }
          if (this.user.mainGroup) {
            this.mainGroup = this.user.mainGroup;
          }

        }
        if (response.status === 204) {
          this.user = response.body;
        }
        if (response.status === 412) {
          this.user = response.body;
        }
      },
      () => {
      },
      () => {
        for (const roles of this.user.roles) {
          if (roles === 'ADMIN') {
            this.isAdmin = true;
          }
          if (roles === 'HEAD') {
            this.isHead = true;
          }
          if (roles === 'PARTNER') {
            this.isPartner = true;
          }
          if (roles === 'USER') {
            this.isUser = true;
          }
          if (roles === 'ADMIN_SPECIALIZATION') {
            this.isSpec = true;
          }
          if (roles === 'STOREKEEPER' || roles === 'ROLE_STOREKEEPER') {
            this.isStorekeeper = true;
          }
        }

        // status;
        this.selectedStatus = this.user.status;
        if (this.selectedStatus === 'ACTIVE') {
          this.activeStatus = true;
          this.inactiveStatus = false;
        }
        if (this.selectedStatus === 'INACTIVE') {
          this.activeStatus = false;
          this.inactiveStatus = true;
        }

        // remote access;
        if (this.user.isRemoteAccessAllowed) {
          this.changeRemove('ALLOW_REMOTE_ACCESS');
        } else {
          this.changeRemove('DISABLE_REMOTE_ACCESS');
        }

        // testing;
        if (this.user.isTestingDisabled) {
          this.changeTesting('DISABLE_TESTING');
        } else {
          this.changeTesting('ENABLE_TESTING');
        }

        if (this.user.isClothingIssueDisabled) {
          this.changeClothingIssue('DISABLE_CLOTHING_ISSUE');
        } else {
          this.changeClothingIssue('ALLOW_CLOTHING_ISSUE');
        }

        const dateOfEmoloyment = new Date(this.user.dateOfEmployment);
        this.dateOfEmployment = {
          year: dateOfEmoloyment.getFullYear(),
          month: dateOfEmoloyment.getMonth() + 1,
          day: dateOfEmoloyment.getDate()
        };

        if (this.user.dateOfDismissal != null) {
          const dateOfDismissal = new Date(this.user.dateOfDismissal);
          this.dateOfDismissal = {
            year: dateOfDismissal.getFullYear(),
            month: dateOfDismissal.getMonth() + 1,
            day: dateOfDismissal.getDate()
          };
        }
        this.userLocal = this.userService.getLocal();
        this.isLocalAdmin = this.isAdminUser(this.userLocal);

        if (this.user.schedule != null) {
          this.selectedSched(this.user.schedule.id, this.user.schedule.workStart, this.user.schedule.workEnd);
        } else {
          this.selectNullSchedule();
        }

        // get groups
        this.adminService.getUserInfo(this.user.id).subscribe(
          (response: any) => {
            this.groupList = response.body.groupsWithPositions;
            if (this.isEmptyObject(this.groupList)) {
              this.showDepartments = false;
            } else {
              this.showDepartments = true;
            }
          },
          () => {
            this.errorGetDataListInfo = true;
          },
        );
        this.isLoaded = true;
      });
  }

  postiruem(tumbler) {
       this.adminService.postiruem(this.user.id, tumbler).subscribe(
        (response) => {
          this.ngOnInit();
        },
      );
  }

  outsourcing(tumbler) {
    this.adminService.outsorce(this.user.id, tumbler).subscribe(
     (response) => {
       this.ngOnInit();
     },
   );
}

  selectedLang(selectedLanguage: string) {
    this.selectedLanguage = selectedLanguage;
    this.user.language = this.selectedLanguage;
  }

  addDepartments() {
    const modalRef = this.modalService.open(AddDepartments);
    modalRef.result.then((result) => {
      if (result) {
        const pushingDepartment = result.department;
        pushingDepartment['positions'] = result.positions;
        for (let i = 0; i < this.groupList.length; i++) {
          if (this.groupList[i].name === pushingDepartment.name) {
            this.groupList.splice(i, 1);
            break;
          }
        }
        this.groupList.push(pushingDepartment);
        if (!this.isEmptyObject(this.groupList) && this.mainGroup === '') {
          this.mainGroup = this.groupList[0]['id'];
        }
        if (this.isEmptyObject(this.groupList)) {
          this.showDepartments = false;
        } else {
          this.showDepartments = true;
        }
      }
    });
  }

  deleteItem(id) {
    for (let i = 0; i < this.groupList.length; i++) {
      if (this.groupList[i].id === id) {
        this.groupList.splice(i, 1);
        if (this.mainGroup === id) {
          this.mainGroup = '';
        }
      }
    }
    if (this.mainGroup === '' && !this.isEmptyObject(this.groupList)) {
      this.mainGroup = this.groupList[0].id;
    }
    if (this.isEmptyObject(this.groupList)) {
      this.showDepartments = false;
    } else {
      this.showDepartments = true;
    }
  }

  changeIsAdmin() {
    if (this.isAdmin === true) {
      this.isAdmin = false;
      if (this.isHead === false) {
        if (this.isPartner === true) {
          this.noAccessStatus = false;
          this.yesAccessStatus = true;
          this.selectedAccess = 'ALLOW_REMOTE_ACCESS';
        } else {
          this.noAccessStatus = true;
          this.yesAccessStatus = false;
          this.selectedAccess = 'DISABLE_REMOTE_ACCESS';
        }
      }
    } else {
      this.isAdmin = true;
    }
  }

  changeIsHead() {
    if (this.isHead === true) {
      this.isHead = false;
      if (this.isAdmin === false) {
        if (this.isPartner === true) {
          this.noAccessStatus = false;
          this.yesAccessStatus = true;
          this.selectedAccess = 'ALLOW_REMOTE_ACCESS';
        } else {
          this.noAccessStatus = true;
          this.yesAccessStatus = false;
          this.selectedAccess = 'DISABLE_REMOTE_ACCESS';
        }
      }
    } else {
      this.isHead = true;
    }
  }

  changeIsPartner() {
    if (this.isPartner === true) {
      this.isPartner = false;
    } else if (this.isPartner === false) {
      if (this.isUser === true) {
        this.isUser = false;
      }
      this.isPartner = true;
      this.noAccessStatus = false;
      this.yesAccessStatus = true;
      this.selectedAccess = 'ALLOW_REMOTE_ACCESS';
    }
  }

  changeIsUser() {
    if (this.isUser === true) {
      this.isUser = false;
    } else {
      if (this.isPartner === true) {
        this.isPartner = false;
      }
      this.isUser = true;
      this.noAccessStatus = true;
      this.yesAccessStatus = false;
      this.selectedAccess = 'DISABLE_REMOTE_ACCESS';
    }
  }

  changeIsSpec() {
    if (this.isSpec === true) {
      this.isSpec = false;
    } else {
      this.isSpec = true;
    }
  }

  changeIsStorekeeper() {
    if (this.isStorekeeper === true) {
      this.isStorekeeper = false;
    } else {
      this.isStorekeeper = true;
    }
  }

  changeTime(status) {
    if(status === 'ON') {
      this.isCheckTimetable = true;
    }
    if(status === 'OFF') {
      this.isCheckTimetable = false;
    }
  }

  changeTesting(selectedTesting: string) {
    if (selectedTesting === 'ENABLE_TESTING') {
      this.selectedTesting = selectedTesting;
      this.noTestingStatus = true;
      this.yesTestingStatus = false;
      this.yesTesting = true;
    }
    if (selectedTesting === 'DISABLE_TESTING') {
      this.selectedTesting = selectedTesting;
      this.noTestingStatus = false;
      this.yesTestingStatus = true;
      this.yesTesting = false;
    }
  }

  changeRemove(selectedAccess: string) {
    this.selectedAccess = selectedAccess;
    if (selectedAccess === 'DISABLE_REMOTE_ACCESS') {
      this.user.isRemoteAccessAllowed = false;
      this.noAccessStatus = true;
      this.yesAccessStatus = false;
    }
    if (selectedAccess === 'ALLOW_REMOTE_ACCESS') {
      this.noAccessStatus = false;
      this.yesAccessStatus = true;
      this.user.isRemoteAccessAllowed = true;
    }
  }

  changeClothingIssue(selectedClothingIssue: string) {
    this.selectedClothingIssue = selectedClothingIssue;
    if (selectedClothingIssue === 'DISABLE_CLOTHING_ISSUE') {
      this.clothingIssueDisabledStatus = true;
      this.clothingIssueAllowedStatus = false;
      this.user.isClothingIssueDisabled = true;
    }
    if (selectedClothingIssue === 'ALLOW_CLOTHING_ISSUE') {
      this.clothingIssueDisabledStatus = false;
      this.clothingIssueAllowedStatus = true;
      this.user.isClothingIssueDisabled = false;
    }
  }

  selectedStat(selectedStat: string) {
    this.selectedStatus = selectedStat;
    this.user.status = selectedStat;
    if (this.selectedStatus === 'ACTIVE') {
      this.activeStatus = true;
      this.inactiveStatus = false;
    }
    if (this.selectedStatus === 'INACTIVE') {
      this.activeStatus = false;
      this.inactiveStatus = true;
    }
  }



  selectedSched(id, start, end) {
    this.selectedSchedule = start + ' - ' + end;
    this.scheduleForm = id;
  }

  selectNullSchedule() {
    this.selectedSchedule = 'Not assigned';
    this.scheduleForm = null;
  }


  validateFields() {
    return true;
  }

  validateEmailAndPhone() {
    // Email;
    if (this.user.email) {
      if (this.validateEmail(this.user.email)) {
        return this.validatePhone(this.user.phone); // phone;
      } else {
        this.noValidationText = 'THE_EMAIL_FORMAT_IS_NOT_VALID';
        return false;
      }
    } else {
      return this.validatePhone(this.user.phone); // phone;
    }
  }

  // Not an appropriate name for this feature :/
  hasAnyCharacters(s) {
    if (/^[a-zA-Z]+$/.test(s)) {
      return true;
    }
  }

  // Email;
  validateEmail(email) {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }

  // Phone;
  validatePhone(phone) {
    if (this.user.phone) {
      const re = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
      if (re.test(phone)) {
        return re.test(phone);
      } else {
        this.noValidationText = 'THE_PHONE_FORMAT_IS_NOT_VALID';
        return re.test(phone);
      }
    } else {
      return true;
    }
  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;

  }

  isEmptyObject(obj) {
    return (obj && (Object.keys(obj).length === 0));
  }



  submit() {
    this.successInfo = false;
    this.errorInfo = false;
    this.noValidation = false;
    this.isSubmited = true;

    if (this.validateFields()) {
      const modalRef = this.modalService.open(ConfirmationPopupComponent);
      modalRef.componentInstance.massage = 'DO_YOU_WANT_TO_EDIT_THIS_USER';
      modalRef.result.then((result) => {
        if (result === 'ok') {
          this.disableRegBtn = true;

          this.user.roles = [];
          if (this.isAdmin === true) {
            this.user.roles.push('ADMIN');
          }
          if (this.isHead === true) {
            this.user.roles.push('HEAD');
          }
          if (this.isPartner === true) {
            this.user.roles.push('PARTNER');
          }
          if (this.isUser === true) {
            this.user.roles.push('USER');
          }
          if (this.isSpec === true) {
            this.user.roles.push('ADMIN_SPECIALIZATION');
          }
          if (this.isStorekeeper === true) {
            this.user.roles.push('STOREKEEPER');
          }

          this.user.dateOfEmployment = this.parserFormatter.format(this.dateOfEmployment);

          if (this.dateOfDismissal != null) {
            this.user.dateOfDismissal = this.parserFormatter.format(this.dateOfDismissal);
          } else {
            this.user.dateOfDismissal = '';
          }

          this.user.schedule = this.scheduleForm != null ? { id: this.scheduleForm } : null;

          this.user.mainGroup = this.mainGroup;
          this.user.isTestingDisabled = this.yesTestingStatus;
          this.user.isRemoteAccessAllowed = this.yesAccessStatus;
          this.user.isClothingIssueDisabled = this.clothingIssueDisabledStatus;
          this.user.checkTimetable = this.isCheckTimetable;
          this.wrapperUser = {
            user: this.user,
            groupsWithPositions: this.groupList
          };
          this.isSubmited = false;
          this.adminService.updateUser(this.wrapperUser).subscribe(
            (response: any) => {
              if (response.status === 200) {
                this.isSubmited = true;
                this.disableRegBtn = false;
                this.successInfo = true;
                this.errorInfo = false;
                this.noValidation = false;
                if (response.body.id === this.userService.getLocal().id) {
                  const editedUser = this.userService.getLocal();
                  editedUser.language = response.body.language;
                  editedUser.fullName = response.body.firstName + ' ' + response.body.lastName;
                  this.userService.setLocal(editedUser);
                  this.languageSwitcher.setLanguage(response.body.language);
                }
              }
            },
            () => {
              this.isSubmited = true;
              this.disableRegBtn = false;
              this.successInfo = false;
              this.errorInfo = true;
              this.noValidation = false;
            });
        } else {
          this.isSubmited = true;
          this.disableRegBtn = false;
        }
      });
    } else {
      this.isSubmited = true;
      this.noValidation = true;
    }
    this.isSubmited = true;
  }

  changeMain(id) {
    this.mainGroup = id;
  }

  private isAdminUser(user: User): boolean {
    if (!user) {
      return false;
    }
    if (user.role === 'ROLE_ADMIN' || user.role === 'ADMIN') {
      return true;
    }
    if (!user.roles || !user.roles.length) {
      return false;
    }
    return user.roles.includes('ROLE_ADMIN') || user.roles.includes('ADMIN');
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/views/edit-user-profile/edit-user-profile.component.ts